
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","fill-rule":"evenodd","d":"M12.873 7.478v4.14l2.922 2.92a.5.5 0 010 .71l-.53.53a.5.5 0 01-.71 0l-3.293-3.29a.534.534 0 01-.15-.35v-4.66a.5.5 0 01.5-.5h.761a.5.5 0 01.5.5zm8.126 2v-5a.5.5 0 00-.5-.5h-.29a.486.486 0 00-.36.15l-1.492 1.49a9.01 9.01 0 00-11.264-1.16A8.997 8.997 0 003.597 15.22a9.007 9.007 0 0017.402-2.712.498.498 0 00-.13-.37.52.52 0 00-.36-.16h-1.001a.5.5 0 00-.5.47 7.003 7.003 0 01-7.295 6.523 7.002 7.002 0 01-6.698-7.133 7.003 7.003 0 016.978-6.86 6.937 6.937 0 014.933 2.07l-1.781 1.78a.488.488 0 00-.15.36v.29a.5.5 0 00.5.5H20.5a.5.5 0 00.5-.5z","opacity":".75"}})])
          )
        }
      }
    